import { atom } from 'jotai'

export const downloadAtom = atom<boolean>(false)
